import { dlog } from './utils/debug';
// src/firebase.js
import { initializeApp } from 'firebase/app';
import { 
  getDatabase, 
  connectDatabaseEmulator 
} from 'firebase/database';
import { 
  getAuth, 
  connectAuthEmulator 
} from 'firebase/auth';
import { getMessaging } from 'firebase/messaging';
import { getFunctions, httpsCallable } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyBvzEg8QU4v4SinvnGk3KskxMtVDtnULQc",
  authDomain: "whatsthescor.es",
  databaseURL: "https://whats-the-score-5f50e-default-rtdb.firebaseio.com",
  projectId: "whats-the-score-5f50e",
  storageBucket: "whats-the-score-5f50e.appspot.com",
  messagingSenderId: "187612276204",
  appId: "1:187612276204:web:8b9b3a44db2d5ffeb519c0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Database
const db = getDatabase(app);

// Auth
const auth = getAuth(app);

// Functions
const functions = getFunctions(app, 'us-central1');

// Messaging (for notifications)
// Only initialize in production (requires HTTPS)
let messaging = null;
const hostname = window.location.hostname;
const isLocalDev = hostname === 'localhost' || 
                   hostname === '127.0.0.1' || 
                   hostname.startsWith('192.168.') || 
                   hostname.startsWith('10.0.') ||
                   window.location.protocol === 'http:';

if (!isLocalDev) {
  try {
    messaging = getMessaging(app);
    dlog('✅ Firebase Messaging initialized');
  } catch (error) {
    dlog('ℹ️ Messaging not supported in this environment');
  }
} else {
  dlog('🔧 Development mode: Using mock FCM (real FCM requires HTTPS)');
}

// Optional: use local emulator ONLY on localhost
if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
  connectDatabaseEmulator(db, 'localhost', 9005);
  connectAuthEmulator(auth, 'http://localhost:9099');
  dlog('🔧 Connected to Firebase Emulators');
}

export { db, auth, messaging, functions, httpsCallable };
